var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CardMedia, IconButton, Link, Typography, } from '@one-thd/sui-atomic-components';
import { ArrowDown, ArrowUp } from '@one-thd/sui-icons';
import { DateTime } from 'luxon';
import React from 'react';
import { routeBuilder } from '../../../utils/general';
import { buildName } from '../../../utils/order-history/PHTable';
import { InfoAndGuidesPopover } from '../../order-details/InfoAndGuidesPopover/InfoAndGuidesPopover';
import { orderNumberFormat } from '../../shared/order-number-formatter/OrderNumberFormatter';
import { generateOrderOrigin, sliceLongText } from '../util/tableUtils';
import { PoJobNameButton, ProductImages, TablePayments } from './index';
// TODO: Replace Luxon's DateTime.local().toLocaleString(DateTime.DATE_HUGE) with Day.js equivalent
// const formattedDate = dayjs().format('MMMM D, YYYY');
export var PHTableData = function (allLineItemImages, formatOrderOrigin, handleRowClick, index, isAdminRole, order, orderDetailsLoaded, orderParams, searchByObj, searchEnabled, selected, setAlertState, tableHeaderState, orderDetails, orderDetailsError) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19;
    var lineItemData = Object.prototype.hasOwnProperty.call(searchByObj, 'itemDescription');
    var orderDetailsLink = "/myaccount/order-details".concat(routeBuilder(orderParams));
    var tenderModifier = function (tenders) {
        var newTenders = [];
        tenders === null || tenders === void 0 ? void 0 : tenders.forEach(function (tender) {
            var _a;
            if (Number(tender === null || tender === void 0 ? void 0 : tender.amount) < 0) {
                var modifiedTender = __assign(__assign({}, tender), { amount: (_a = tender === null || tender === void 0 ? void 0 : tender.amount) === null || _a === void 0 ? void 0 : _a.toString().replace('-', '') });
                newTenders.push(modifiedTender);
                return;
            }
            newTenders.push(tender);
        });
        return newTenders;
    };
    if (lineItemData) {
        // Line Item Data
        return [
            {
                content: '',
                showTableData: true,
            },
            {
                content: (React.createElement(Typography, { variant: "body-base" }, (order === null || order === void 0 ? void 0 : order.salesDate) &&
                    DateTime.fromISO((_a = order === null || order === void 0 ? void 0 : order.salesDate) !== null && _a !== void 0 ? _a : '').toFormat('LL/dd/yy'))),
                isAdmin: true,
                align: '',
                style: { width: '129px' },
                verticalAlign: '',
                showTableData: true,
            },
            {
                content: (React.createElement(ProductImages, { isLoading: searchEnabled ? false : orderDetailsLoaded === false, lineItems: searchEnabled ? [order] : allLineItemImages, maxShow: 4, variant: "medium", hideCanceled: false })),
                style: { width: '78px' },
                showTableData: true,
            },
            {
                content: (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-1 sui-my-[10px] sui-mr-3" },
                    React.createElement(Link, { variant: "body-base", href: orderDetailsLink }, sliceLongText("".concat((_b = order === null || order === void 0 ? void 0 : order.description) !== null && _b !== void 0 ? _b : ''), 28)),
                    React.createElement(Typography, { variant: "body-base", color: "subtle" },
                        "SKU ", (_c = order === null || order === void 0 ? void 0 : order.skuNumber) !== null && _c !== void 0 ? _c : ''),
                    ((_e = (_d = order === null || order === void 0 ? void 0 : order.documents) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0) > 0 && (React.createElement(InfoAndGuidesPopover, { documents: order === null || order === void 0 ? void 0 : order.documents, internetSKU: order === null || order === void 0 ? void 0 : order.omsId, modelNumber: order === null || order === void 0 ? void 0 : order.modelNumber, storeSKU: (order === null || order === void 0 ? void 0 : order.storeSKU) ||
                            (order === null || order === void 0 ? void 0 : order.skuNumber) })))),
                style: { width: '145px' },
                showTableData: true,
            },
            {
                content: (React.createElement(Link, { variant: "body-base", href: orderDetailsLink }, (_f = order === null || order === void 0 ? void 0 : order.orderNumber) !== null && _f !== void 0 ? _f : '')),
                style: { width: '129px' },
                showTableData: true,
            },
            {
                content: (React.createElement(Typography, { variant: "body-base" }, (_h = (Boolean(order === null || order === void 0 ? void 0 : order.transactionId) &&
                    Boolean(order === null || order === void 0 ? void 0 : order.registerNumber) &&
                    "".concat((_g = order === null || order === void 0 ? void 0 : order.registerNumber) === null || _g === void 0 ? void 0 : _g.toString(), "-").concat(order === null || order === void 0 ? void 0 : order.transactionId))) !== null && _h !== void 0 ? _h : '')),
                style: { width: '129px' },
                showTableData: true,
            },
            {
                content: (React.createElement(Typography, { variant: "body-base" }, (_j = order === null || order === void 0 ? void 0 : order.quantity) !== null && _j !== void 0 ? _j : '')),
                style: { width: '115px' },
                showTableData: true,
            },
            {
                content: (React.createElement(Typography, { variant: "body-base" },
                    "$", (_l = (_k = order === null || order === void 0 ? void 0 : order.originalUnitPrice) === null || _k === void 0 ? void 0 : _k.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })) !== null && _l !== void 0 ? _l : '')),
                style: { width: '94px' },
                showTableData: true,
            },
            {
                content: (React.createElement(Typography, { variant: "body-base" },
                    "$", (_o = (_m = order === null || order === void 0 ? void 0 : order.otherDiscountAmount) === null || _m === void 0 ? void 0 : _m.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })) !== null && _o !== void 0 ? _o : '')),
                style: { width: '101px' },
                showTableData: true,
            },
            {
                content: (React.createElement(Typography, { variant: "body-base" },
                    "$", (_q = (_p = order === null || order === void 0 ? void 0 : order.netUnitPrice) === null || _p === void 0 ? void 0 : _p.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })) !== null && _q !== void 0 ? _q : '')),
                style: { width: '105px' },
                showTableData: true,
            },
        ];
    }
    // Table Data
    return [
        {
            content: searchEnabled ? (React.createElement("div", null)) : (React.createElement(React.Fragment, null,
                React.createElement(IconButton, { onClick: function () { return handleRowClick(index); }, icon: selected[index] === index ? ArrowUp : ArrowDown }))),
            verticalAlign: 'middle',
            align: 'center',
            showTableData: true,
        },
        {
            content: ((_r = Object.keys(searchByObj)) === null || _r === void 0 ? void 0 : _r.length) === 0 ||
                ((_s = Object.keys(searchByObj)) === null || _s === void 0 ? void 0 : _s[0]) === 'itemDescription' ? (React.createElement(ProductImages, { isLoading: orderDetailsLoaded === false, lineItems: allLineItemImages !== null && allLineItemImages !== void 0 ? allLineItemImages : [], maxShow: 3, variant: "small" })) : (React.createElement("div", { style: {
                    width: '32px',
                    height: '32px',
                } },
                React.createElement(CardMedia, { src: "https://assets.thdstatic.com/images/v1/no-img.svg", alt: "Unavailable image" }))),
            showTableData: (_t = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[0]) === null || _t === void 0 ? void 0 : _t.enabled,
        },
        {
            content: (React.createElement(Link, { variant: "body-base", href: orderDetailsLink }, orderNumberFormat((_u = order === null || order === void 0 ? void 0 : order.orderNumber) !== null && _u !== void 0 ? _u : (_v = order === null || order === void 0 ? void 0 : order.orderNumbers) === null || _v === void 0 ? void 0 : _v[0], (_w = order === null || order === void 0 ? void 0 : order.transactionIdWithCheckDigit) !== null && _w !== void 0 ? _w : order === null || order === void 0 ? void 0 : order.transactionId, order === null || order === void 0 ? void 0 : order.registerNumber, false).toUpperCase())),
            showTableData: (_x = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[1]) === null || _x === void 0 ? void 0 : _x.enabled,
        },
        {
            content: (React.createElement(Typography, { variant: "body-base" }, (order === null || order === void 0 ? void 0 : order.salesDate) &&
                DateTime.fromISO((_y = order === null || order === void 0 ? void 0 : order.salesDate) !== null && _y !== void 0 ? _y : '').toFormat('LL/dd/yy'))),
            showTableData: (_z = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[2]) === null || _z === void 0 ? void 0 : _z.enabled,
        },
        {
            content: formatOrderOrigin((_0 = generateOrderOrigin(order)) !== null && _0 !== void 0 ? _0 : ''),
            showTableData: (_1 = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[3]) === null || _1 === void 0 ? void 0 : _1.enabled,
        },
        {
            content: (React.createElement(Typography, { variant: "body-base" }, sliceLongText((_2 = order === null || order === void 0 ? void 0 : order.projectName) !== null && _2 !== void 0 ? _2 : '', 28))),
            showTableData: (_4 = (_3 = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[4]) === null || _3 === void 0 ? void 0 : _3.enabled) !== null && _4 !== void 0 ? _4 : true,
        },
        {
            content: React.createElement(PoJobNameButton, { order: order, setAlertState: setAlertState }),
            showTableData: (_5 = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[5]) === null || _5 === void 0 ? void 0 : _5.enabled,
            style: { width: '124px' },
        },
        {
            content: (React.createElement(TablePayments, { orderNumber: (_6 = order === null || order === void 0 ? void 0 : order.orderNumber) !== null && _6 !== void 0 ? _6 : (_7 = order === null || order === void 0 ? void 0 : order.orderNumbers) === null || _7 === void 0 ? void 0 : _7[0], receiptDetails: order === null || order === void 0 ? void 0 : order.receiptDetails, tenders: tenderModifier((_8 = order === null || order === void 0 ? void 0 : order.tenders) !== null && _8 !== void 0 ? _8 : []), orderDetailsLoaded: orderDetailsLoaded, paymentMethods: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.paymentMethods, orderDetailsError: orderDetailsError })),
            showTableData: (_9 = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[6]) === null || _9 === void 0 ? void 0 : _9.enabled,
        },
        {
            content: (React.createElement(Typography, { variant: "body-base", style: {
                    overflow: 'hidden',
                    width: '103px',
                } }, sliceLongText(buildName((_10 = order === null || order === void 0 ? void 0 : order.purchaserFirstName) !== null && _10 !== void 0 ? _10 : '', (_11 = order === null || order === void 0 ? void 0 : order.purchaserLastName) !== null && _11 !== void 0 ? _11 : '', order === null || order === void 0 ? void 0 : order.buyerName, order === null || order === void 0 ? void 0 : order.buyerId), 28))),
            isAdmin: isAdminRole,
            showTableData: (_12 = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[7]) === null || _12 === void 0 ? void 0 : _12.enabled,
        },
        {
            content: (React.createElement(Typography, { variant: "body-base", style: {
                    overflow: 'hidden',
                    width: '103px',
                } }, sliceLongText((_13 = order === null || order === void 0 ? void 0 : order.nickName) !== null && _13 !== void 0 ? _13 : '', 28))),
            showTableData: (_14 = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[8]) === null || _14 === void 0 ? void 0 : _14.enabled,
        },
        {
            content: (React.createElement(Typography, { variant: "body-base" },
                (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.statusDescription) === 'Returned' ? '-' : '',
                "$", (_18 = (_17 = ((_16 = (_15 = order === null || order === void 0 ? void 0 : order.returnTotal) !== null && _15 !== void 0 ? _15 : order === null || order === void 0 ? void 0 : order.totalAmount) !== null && _16 !== void 0 ? _16 : order === null || order === void 0 ? void 0 : order.originalUnitPrice)) === null || _17 === void 0 ? void 0 : _17.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })) !== null && _18 !== void 0 ? _18 : '---')),
            style: { width: '92px' },
            showTableData: (_19 = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[9]) === null || _19 === void 0 ? void 0 : _19.enabled,
        },
    ];
};
